<!--排行榜-->
<template>
  <div class="content">
    <div class="top-bj"></div>
    <div class="main-box">
      <div class="top-line"></div>
      <div class="content-box">
        <img class="xian-l" src="../../assets/images/xian.png" alt="">
        <img class="xian-r" src="../../assets/images/xian.png" alt="">
        <div class="top">
          <div class="left-img" v-if="myData&&myData.score">
            <img :src="myData.avatar" alt="">
          </div>
          <div class="right-text" v-if="myData&&myData.score">
            <div class="text-l">
              <span>{{ isunit? "单位名" : "用户名" }}</span>
              <span>{{myData.user_name || myData.company_name}}</span>
            </div>
            <div class="text-r">
              <span v-if="myData.ranking>0"><span class="fs" >{{myData.score}}</span>分</span>
              <span v-if="myData.ranking>0">第 {{myData.ranking}} 名</span>
              <span v-else>未作答</span>
            </div>
          </div>
        </div>
<!--        个人-->
        <div class="bottom" v-show="!isunit">
          <div class="tab-title">
            <span class="ranking">名次</span>
            <span class="name">姓名</span>
            <span class="tel">手机号</span>
            <span class="fraction">{{$store.state.settingData.exam.rank_display=='1'?'最高分':'总分'}}</span>
          </div>
          <div class="tab-body">
            <Scroll :on-reach-bottom="handleReachBottom">
              <div class="tab-data" v-for="(item,index) in dataArr">
                <span class="ranking" v-if="index === 0"><img src="../../assets/images/one.png" alt=""></span>
                <span class="ranking" v-if="index === 1"><img src="../../assets/images/two.png" alt=""></span>
                <span class="ranking" v-if="index === 2"><img src="../../assets/images/three.png" alt=""></span>
                <span class="ranking"
                      v-if="index!==0 && index !==1 && index !==2 ">{{index+1}}</span>
                <span class="name">{{item.user_name}}</span>
                <span class="tel">{{item.mobile | filterMobile}}</span>
                <span class="fraction"><span>{{item.score}}</span>分</span>
              </div>
            </Scroll>
          </div>
        </div>
<!--        单位-->
        <div class="bottom" v-show="isunit">
          <div class="tab-title">
            <span class="ranking">名次</span>
            <span :class="{name:isDetail,tel:!isDetail}">{{ isDetail? "姓名" : "单位名" }}</span>
            <span :class="{name:!isDetail,tel:isDetail}">{{ isDetail? "手机号" : "人次" }}</span>
            <span class="fraction">总分</span>
          </div>
          <div class="tab-body">
            <Scroll :on-reach-bottom="handleReachBottom">
              <div class="tab-data" v-for="(item,index) in dataArr" @click="getCompanyDetail(item.company_id)">
                <span class="ranking" v-if="index === 0"><img src="../../assets/images/one.png" alt=""></span>
                <span class="ranking" v-if="index === 1"><img src="../../assets/images/two.png" alt=""></span>
                <span class="ranking" v-if="index === 2"><img src="../../assets/images/three.png" alt=""></span>
                <span class="ranking"
                      v-if="index!==0 && index !==1 && index !==2">{{index+1}}</span>
                <span class="name" v-if="isDetail">{{item.user_name}}</span>
                <span class="tel" :class="{mid:item.company_name&&item.company_name.length>7,long:item.company_name&&item.company_name.length>15}" v-if="!isDetail">{{item.company_name}}</span>
                <span class="tel" v-if="isDetail">{{item.mobile | filterMobile}}</span>
                <span class="name" v-if="!isDetail">{{item.count}}</span>
                <span class="fraction"><span>{{item.all_score || item.score}}</span>分</span>
              </div>
            </Scroll>
          </div>
        </div>
        <div class="switch" v-show="$store.state.settingData.form_type === 3 && $route.query.id != '1045'">
          <Button :type="isunit?null:'primary'" @click="switchBtn(false)">个人榜单</Button>
          <Button :type="isunit?'primary':null" @click="switchBtn(true)" v-if="$route.query.id != '1270'">单位榜单</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getRanking,getCompanyranking} from "../../api/Interface";

    export default {
        name: "ranking",
        data() {
            return {
                tabHeight: 450,
                dataArr: [],
                myData: {},
                perData: {},
                companyData: {},
                personRank: [],
                companyRank: [],
                page: 1,
                isunit: false,     //  true单位榜单  false个人榜单
                isDetail: false     // 是否为详情页
            }
        },
      mounted() {
            this.getCompanyrankingData()
            this.getRankingData()
        },
        methods: {
            getRankingData() {
                let data = {
                    form_id: this.$route.query.id,
                    submit_id: this.$store.state.userInfoId,
                    pagesize: 30,
                    page: this.page
                }
                getRanking(data).then(res => {
                    if (res.state) {
                        this.dataArr = [...this.dataArr, ...res.data]
                        this.personRank = [...this.personRank, ...res.data]
                        this.myData = res.my_result
                        this.perData = res.my_result
                    }
                  console.log(this.dataArr)
                }).catch(error => {
                    console.log(error);
                })
            },
            getCompanyrankingData() {
                let data = {
                    form_id: this.$route.query.id,
                    submit_id: this.$store.state.userInfoId,
                    pagesize: 30,
                    page: this.page
                }
            getCompanyranking(data).then(res => {
                    if (res.state) {
                        this.companyRank = [...this.companyRank, ...res.data]
                        this.companyData = res.my_result
                    }
                }).catch(error => {
                    console.log(error);
                })
            },
            handleReachBottom() {
                return new Promise(resolve => {
                    setTimeout(() => {
                        this.page++
                        this.getRankingData()
                        resolve();
                    }, 2000);
                });
            },
            switchBtn(type){
                this.isunit = type
                this.isDetail = false
              if(this.isunit){
                this.dataArr = this.companyRank
                this.myData = this.companyData
              }else {
                this.dataArr = this.personRank
                this.myData = this.perData
              }
            },
          getCompanyDetail(id){
              // 如果是单位详情就不请求
            if(this.isDetail){
              return
            }
            let data = {
              form_id: this.$route.query.id,
              submit_id: this.$store.state.userInfoId,
              pagesize: 30,
              page: this.page,
              company_id: id
            }
            getRanking(data).then(res => {
              if (res.state) {
                this.dataArr = []
                this.dataArr = [...this.dataArr, ...res.data]
                this.isDetail = true
              }
              console.log(this.dataArr)
            }).catch(error => {
              console.log(error);
            })
          }
        },
        filters:{
          filterMobile(val){
            if(val){
              return val.replace(val.substring(3,7), "****")
            }
            
          }
        }
    }
</script>

<style lang="scss" scoped>
  .content {
    .top-bj {
      width: 100%;
      height: 130px;
      background: url("../../assets/images/top_bj.png") no-repeat top;
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .main-box {
      height: calc(100% - 45px);
      background-color: #fcfcfc;
      position: absolute;
      top: 45px;
      left: 0;
      right: 0;
      bottom: 0;

      .top-line {
        height: 20px;
        background: #1a4bff;
        border: 4px solid #256eff;
        border-radius: 11px;
        box-shadow: 0 3px 6px 0 rgba(0, 53, 157, 0.62);
        margin: 10px 10px 0 10px;
        position: relative;
        z-index: 999;
      }

      .content-box {
        height: calc(100% - 22px);
        display: block;
        margin: 0 20px;
        position: relative;

        .xian-l, .xian-r {
          position: absolute;
          z-index: 9999;
          top: 87px;
          height: 27px;
        }

        .xian-l {
          left: 20px;
        }

        .xian-r {
          right: 20px;
        }

        .top {
          width: 100%;
          height: 92px;
          background-color: #ffffff;
          box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
          position: relative;
          z-index: 999;
          margin-top: -8px;
          display: flex;
          padding: 20px;

          .left-img {
            width: 58px;
            height: 58px;
            flex-shrink: 0;

            img {
              border-radius: 50%;
            }
          }

          .right-text {
            height: 58px;
            color: #2F3246;
            font-size: 16px;
            font-weight: 500;
            flex: 1;
            display: flex;
            justify-content: space-between;

            > div {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: inherit;
              padding-left: 12px;

              .fs {
                color: #FF6766;
              }
            }
          }
        }

        .bottom {
          width: 100%;
          height: calc(100% - 130px);
          background-color: #ffffff;
          box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
          margin-top: 16px;

          .tab-title {
            color: #C8C8C8;
            font-size: 16px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .tab-body {
            height: calc(100% - 160px);
            /*overflow-y: auto;*/
            /deep/ .ivu-scroll-container {
              height: calc(100vh - 350px) !important;
            }

          }


          .tab-data {
            color: #141414;
            font-size: 16px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 500;

            &:nth-child(odd) {
              background-color: #f8f9ff;
            }
          }

          .ranking {
            width: 60px;
            text-align: center;

            img {
              width: 22px;
              height: 22px;
            }
          }

          .name {
            flex: 1;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .tel {
            flex: 2;
            text-align: center;
            &.mid{
              line-height: 26px;
              font-size:14px;
            }
            &.long{
              line-height: 17px;
              font-size:12px;
            }
          }

          .fraction {
            width: 60px;
            text-align: center;

            span {
              color: #FF6766;
            }
          }
        }
        .switch{
          margin-top: -42px;
          z-index: 999;
          position: absolute;
          /deep/.ivu-btn{
            margin: 0 2px;
          }
        }
      }
    }
  }
</style>

